import { PaletteOptions } from "@mui/material";

export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: {
    main: "#183D3D",
  },
  secondary: {
    main: "#5C8374",
  },
  background: {
    default: "rgb(244, 246, 254)",
    paper: "rgb(244, 246, 254)",
  },
  success: {
    main: "#67be23",
    contrastText: "#fff",
  },
  error: {
    main: "#ee2a1e",
    contrastText: "#fff",
  },
  warning: {
    main: "#fa8c16",
    contrastText: "#fff",
  },
  info: {
    main: "#1890ff",
    contrastText: "#fff",
  },
  text: {
    primary: "#000",
    secondary: "#5C8374",
    disabled: "#d1d1d1",
  },
};
